export enum MessagesActions {
  Reset = "reset",
  FetchMessages = "fetchMessages",
  FetchMessage = "fetchMessage",
  ReadMessage = "readMessage",
  SendMessage = "sendMessage",
  FetchUnreadMessages = "fetchUnreadMessages",
}
